
import { useState, useEffect } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

const slides = [
    {
        id: 1,
        image: "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/test3.jpg",
        title: "Welcome Back",
        description: "Sign in to access your account and continue your journey with us.",
    },
    {
        id: 2,
        image: "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/girl-taking-selfie-studio.jpg",
        title: "Secure Access",
        description: "Your security is our priority. We use advanced encryption to protect your data.",
    },
    {
        id: 3,
        image: "https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/images/test4.jpg",
        title: "24/7 Support",
        description: "Need help? Our support team is available around the clock to assist you.",
    },
]

export default function ImageSlider() {
    const [currentSlide, setCurrentSlide] = useState(0)

    // Auto-rotate slides
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
        }, 5000)

        return () => clearInterval(interval)
    }, [])

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
    }

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
    }

    return (
        <div className="h-full relative overflow-hidden bg-gradient-to-br from-slate-900 to-slate-950 text-white">
            {/* Slides */}
            
            <div className="h-full">
                {slides.map((slide, index) => (
                    <div className="w-full" key={slide.id}>
                    <div
                        className={`!absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"}`}
                    >
                        {/* Background image with high-end dark styling */}
                        <div
                            className="!absolute inset-0 bg-cover bg-center opacity-40 mix-blend-luminosity"
                            style={{ backgroundImage: `url(${slide.image})` }}
                        />
                        
                        {/* Dark vignette overlay for depth */}
                        {/* <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" /> */}

                        {/* Foreground content */}
                        <div className="relative z-10 flex flex-col items-center justify-center h-full p-8 sm:p-12 text-center space-y-4">
                            <h2 className="text-3xl sm:text-4xl font-black text-white tracking-tight drop-shadow-md">{slide.title}</h2>
                            <p className="text-sm sm:text-base text-slate-300 font-medium leading-relaxed max-w-sm drop-shadow-sm">{slide.description}</p>
                        </div>
                    </div>
                    </div>
                ))}
            </div>

            {/* Navigation dots */}
            <div className="!absolute bottom-8 left-0 right-0 flex justify-center gap-2 z-20">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentSlide ? "bg-white scale-125" : "bg-white/50"}`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
            
            {/* Navigation arrows */}
            {/* <button
                onClick={prevSlide}
                className="!absolute left-4 top-1/2 -translate-y-1/2 bg-black/20 hover:bg-black/30 rounded-full p-2 z-20"
                aria-label="Previous slide"
            >
                <ChevronLeft className="h-6 w-6" />
            </button>
            <button
                onClick={nextSlide}
                className="!absolute right-4 top-1/2 -translate-y-1/2 bg-black/20 hover:bg-black/30 rounded-full p-2 z-20"
                aria-label="Next slide"
            >
                <ChevronRight className="h-6 w-6" />
            </button> */}
        </div>
    )
}
